import React, { useState } from "react";
import axios from "axios";


const useAutoReply = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [autoReplyOption, setKeywordOption] = useState([])
    const mainApi = '/app/autoreply'
    const getAutoReplyOption = (params) => {
        axios.get(mainApi, {
            params: {
               
            }
        })
            .then((response) => {
                let data = response.data.data
                data = data.map((value) => {
                    return {
                        label: value?.autoreply_name,
                        value: value?.autoreply_id,
                        ...value
                    }
                })
                setKeywordOption(data)
            });
    }
    const getAutoReplyData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postAutoReplyData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchAutoReplyData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "failure") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteAutoReplyData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        autoReplyOption: autoReplyOption,
        autoReplyData: data,
        getAutoReplyData,
        postAutoReplyData,
        patchAutoReplyData,
        deleteAutoReplyData,
        getAutoReplyOption
    }
}
export { useAutoReply }
